import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

// Something to consider. The orignal app just searched and returned the cloudid
// then matched the users up to the getMemberList call that we know is cached
// this one, we'll retrieve exactly the same details that would come out of a getMemberList call
// as it'll simplify the calling code. Less efficient, can be improved later on
// You know what'd be nice for this very specific case? Fragments. Fairly sure they're a graphql thing
export const SEARCH_USERS_QUERY = gql`
  query SearchUsers($activeJobManager: Boolean, $activeJobPartner: Boolean) {
    searchUsers(
      activeJobManager: $activeJobManager
      activeJobPartner: $activeJobPartner
    ) {
      cloudId
      fullName
      email
      active
      workflowRole
      administrator
      licensed
      roleName
      partner
      manager
    }
  }
` as import('../../__generated__/ts-gql/SearchUsers').type;

export type SearchUsersQueryVariables = OperationVariables<
  typeof SEARCH_USERS_QUERY
>;
export type SearchUsersQueryResult = OperationData<typeof SEARCH_USERS_QUERY>;

export type SearchUsersResult = NonNullable<
  SearchUsersQueryResult['searchUsers']
>[number];

export const useSearchUsers = (
  options: QueryHookOptions<SearchUsersQueryResult, SearchUsersQueryVariables>
) => {
  const variables = options.variables as SearchUsersQueryVariables;

  const res = useQuery(SEARCH_USERS_QUERY, {
    context: { service: 'users' },
    variables,
    ...options,
  });

  // I don't really like sorting here, feels like sorting should happen in the calling code. But, it's also
  // a potentially expensive thing to do, we want to avoid this in a render loop
  // and a lot of the usage of this would need to be re-worked to avoid conditional hook usage if this was to be useMemo'd
  // Also, if people refetch, they'll get data in different order :(
  return React.useMemo(
    () => ({
      ...res,
      data: res.data?.searchUsers,
    }),
    [res]
  );
};
